// extracted by mini-css-extract-plugin
module.exports = {"root":"phAq7fO8","light":"r3UR5c5B","dark":"kIehOOpq"};